import { useEffect } from "react";
import "./style.scss"
const Singapore = () => {
    useEffect(() => {
        document.title = '港澳中文補習，幼小銜接，閱讀寫作專項';
    }, [])

    return <div className="hkonline">
        <img src="../assets/AdImg/bagF.png" alt="" />
        <div className="icon_boxF">
            <a href="https://wa.me/8617788052878?text=%E4%BA%86%E8%A7%A3%E7%9B%B8%E9%97%9C%E8%AA%B2%E7%A8%8B">
                <img src="../assets/whatsapp.png" alt="" className="mbs_icon" />
            </a>
        </div>
    </div>
}
export default Singapore;